(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('load', (event) => {
    const img = event.target;
    if (!img.classList?.contains('product-media__image')) return;
    if (img !== document.querySelector('.product-media__image')) return;
    document.querySelector('media-gallery slideshow-component')?.select(0);
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcs-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('tcs-form')) return;
    var boxes = form.querySelectorAll('[data-tcs-social]');
    if (!boxes.length) return;
    var anyChecked = Array.prototype.some.call(boxes, function (b) { return b.checked; });
    if (!anyChecked) {
      event.preventDefault();
      boxes[0].setCustomValidity('Please choose at least one social media account.');
      boxes[0].reportValidity();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-tcs-social]')) return;
    event.target.closest('form').querySelectorAll('[data-tcs-social]').forEach(function (b) { b.setCustomValidity(''); });
  });

  document.addEventListener('click', function (event) {
    var copy = event.target.closest('[data-tcs-copy]');
    if (copy) {
      navigator.clipboard.writeText(copy.dataset.tcsCopy).then(function () {
        copy.textContent = 'Copied!';
        setTimeout(function () { copy.textContent = 'Copy code'; }, 2000);
      });
      return;
    }

    var video = event.target.closest('[data-tcs-video]');
    if (video) {
      var frame = document.createElement('iframe');
      frame.className = 'tcs-video__frame';
      frame.src = 'https://www.youtube-nocookie.com/embed/' + video.dataset.tcsVideo + '?autoplay=1&rel=0';
      frame.title = video.getAttribute('aria-label') || 'Video';
      frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      video.replaceWith(frame);
      return;
    }

    var photo = event.target.closest('[data-tcs-photo]');
    if (!photo) return;
    var dialog = document.getElementById('tcs-lightbox');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'tcs-lightbox';
      dialog.className = 'tcs-lightbox';
      dialog.innerHTML = '<button type="button" class="tcs-lightbox__close" aria-label="Close">&times;</button><img alt=""><p></p>';
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('.tcs-lightbox__close')) dialog.close();
      });
      document.body.appendChild(dialog);
    }
    var img = dialog.querySelector('img');
    img.src = photo.dataset.tcsPhoto;
    img.alt = photo.dataset.tcsCaption || '';
    dialog.querySelector('p').textContent = photo.dataset.tcsCaption || '';
    dialog.showModal();
  });

  } catch(e) { console.error(e); }
})();
})();
